import React, { useEffect, useState } from "react";
import DynamicBanner from "../../Pages/include/DynamicBanner";
import "./GeneralHospital.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import api from "../../../api";
import { Link } from "react-router-dom";

const GeneralHospital = () => {
  const [aboutData, setAboutData] = useState(null);
  const [wasteData, setWasteData] = useState([]);
  const [guideData, setGuideData] = useState([]);
  const [outpatientData, setOutpatientData] = useState(null);
  const [inpatientData, setInpatientData] = useState(null);
  const [departmentsData, setDepartmentsData] = useState([]);
  const [communityData, setCommunityData] = useState(null);
  const [testimonialData, setTestimonialData] = useState(null);
  const [diagnosticData, setDiagnosticData] = useState(null);
  const [satelliteData, setSatelliteData] = useState(null); // New state
  const [loading, setLoading] = useState(true);

  const poonjeriSliderSettings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    loop: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const communitySliderSettings = {
    dots: false,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplaySpeed: 2500,
    arrows: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const res = await api.get("/api/hospital/about");
        const data = res.data;

        data.banner_data.desktop_images = data.banner_data.desktop_images?.map(
          (img) => (img.startsWith("/") ? img : `/${img}`),
        );

        data.banner_data.mobile_images = data.banner_data.mobile_images?.map(
          (img) => (img.startsWith("/") ? img : `/${img}`),
        );

        setAboutData(data);
      } catch (err) {
        console.error("Hospital About API error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAbout();
  }, []);

  useEffect(() => {
    const fetchWasteDetails = async () => {
      try {
        const res = await api.get("/api/hospital/waste-details");
        const items = res.data?.waste_items || [];

        // normalize image paths
        const normalized = items.map((item) => ({
          ...item,
          image_url: item.image_url.startsWith("/")
            ? item.image_url
            : `/${item.image_url}`,
        }));

        setWasteData(normalized);
      } catch (err) {
        console.error("Waste details API error:", err);
      }
    };

    fetchWasteDetails();
  }, []);

  useEffect(() => {
    const fetchGuideDetails = async () => {
      try {
        const res = await api.get("/api/hospital/guide-details");
        setGuideData(res.data?.guide_groups || []);
      } catch (err) {
        console.error("Guide details API error:", err);
      }
    };

    fetchGuideDetails();
  }, []);

  useEffect(() => {
    const fetchInpatientDetails = async () => {
      try {
        const res = await api.get("/api/hospital/inpatient-details");
        setInpatientData(res.data);
      } catch (err) {
        console.error("Inpatient API error:", err);
      }
    };

    fetchInpatientDetails();
  }, []);

  useEffect(() => {
    if (loading) return;

    const buttons = document.querySelectorAll(".accordion-button");

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const target = btn.getAttribute("data-bs-target");
        const collapseEl = document.querySelector(target);

        if (!collapseEl) return;

        collapseEl.addEventListener(
          "shown.bs.collapse",
          () => {
            btn.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          },
          { once: true },
        );
      });
    });
  }, [loading]);

  useEffect(() => {
    const fetchCommunityData = async () => {
      try {
        const res = await api.get("/api/hospital/community-engagement-details");
        setCommunityData(res.data);
      } catch (err) {
        console.error("Community engagement API error:", err);
      }
    };

    fetchCommunityData();
  }, []);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const res = await api.get("/api/general-hospital/departments");
        setDepartmentsData(res.data.categories || []);
      } catch (err) {
        console.error("Departments API error:", err);
      }
    };

    fetchDepartments();
  }, []);

  useEffect(() => {
    const fetchOutpatientDetails = async () => {
      try {
        const res = await api.get("/api/hospital/outpatient-details");
        setOutpatientData(res.data);
      } catch (err) {
        console.error("Outpatient API error:", err);
      }
    };

    fetchOutpatientDetails();
  }, []);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await api.get("/api/hospital/testimonials-details");
        setTestimonialData(res.data);
      } catch (error) {
        console.error("Failed to load testimonials", error);
      }
    };

    fetchTestimonials();
  }, []);

  useEffect(() => {
    const fetchDiagnosticDetails = async () => {
      try {
        const res = await api.get("/api/hospital/diagnostic-details");
        setDiagnosticData(res.data);
      } catch (error) {
        console.error("Failed to load diagnostic details", error);
      }
    };

    fetchDiagnosticDetails();
  }, []);

  // Fetch Satellite Centres Data
  useEffect(() => {
    const fetchSatellite = async () => {
      try {
        const res = await api.get("/api/hospital/satellite-details");
        setSatelliteData(res.data);
      } catch (error) {
        console.error("Failed to load satellite details", error);
      }
    };
    fetchSatellite();
  }, []);

  const renderBlocks = (blocks = []) => {
    return blocks.map((block, idx) => {
      if (block.block_type === "title") {
        return (
          <h3 key={idx} className="mb-4 mt-4">
            {block.text}
          </h3>
        );
      }

      if (block.block_type === "paragraph") {
        return <p key={idx}>{block.text}</p>;
      }

      if (block.block_type === "list") {
        return (
          <ul key={idx} className="opcare-list">
            {block.list_items.map((item, i) => (
              <li key={i}>
                <i className="fa fa-check-circle-o me-2"></i>
                {item}
              </li>
            ))}
          </ul>
        );
      }

      return null;
    });
  };

  if (loading || !aboutData) {
    return null;
  }

  const AboutContent = () => (
    <div className="document-box">
      <div className="sec-title text-center py-3">
        <h2>Chettinad General Hospital – Healthcare for All</h2>
      </div>

      {aboutData.sections.map((section, idx) => (
        <div key={idx} dangerouslySetInnerHTML={{ __html: section.content }} />
      ))}

      <ul className="visitor">
        {aboutData.carousel_sections.map((center, cIdx) => (
          <li className="facility-item mb-0" key={cIdx}>
            <div className="rural-centers">{center.title}</div>
            <p>{center.description}</p>

            <div className="hospital-slider mt-3">
              <Slider {...poonjeriSliderSettings}>
                {center.images.map((img, iIdx) => (
                  <div className="slide-item text-center" key={iIdx}>
                    <img
                      src={`${process.env.REACT_APP_API_URL}/public${img}`}
                      className="img-fluid rounded"
                      alt={center.title}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
  const GuideContent = ({ prefix = "desktop" }) => (
    <div className="document-box">
      <div className="sec-title text-center py-3">
        <h2>Patient & Visitors Guide</h2>
      </div>

      {/* Tabs */}
      <ul className="nav nav-tabs general-tabs mt-3" role="tablist">
        {guideData.map((group, gIdx) => (
          <li className="nav-item" key={gIdx}>
            <button
              className={`nav-link ${gIdx === 0 ? "active" : ""}`}
              data-bs-toggle="tab"
              data-bs-target={`#${prefix}-guide-tab-${gIdx}`}
              type="button"
            >
              {group.parent_title}
            </button>
          </li>
        ))}
      </ul>

      <div className="tab-content p-md-3 py-2">
        {guideData.map((group, gIdx) => (
          <div
            key={gIdx}
            className={`tab-pane fade ${gIdx === 0 ? "show active" : ""}`}
            id={`${prefix}-guide-tab-${gIdx}`}
          >
            <div className="accordion" id={`${prefix}-guideAccordion-${gIdx}`}>
              {group.accordion_sections.map((section, sIdx) => (
                <div className="accordion-item" key={sIdx}>
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button ${sIdx !== 0 ? "collapsed" : ""}`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#${prefix}-collapse-${gIdx}-${sIdx}`}
                    >
                      {section.section_title}
                    </button>
                  </h2>

                  <div
                    id={`${prefix}-collapse-${gIdx}-${sIdx}`}
                    className={`accordion-collapse collapse ${sIdx === 0 ? "show" : ""}`}
                    data-bs-parent={`#${prefix}-guideAccordion-${gIdx}`}
                  >
                    <div className="accordion-body">
                      {renderBlocks(section.content_blocks)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const OutPatientContent = () => (
    <div className="document-box">
      {outpatientData && (
        <section className="opd-section">
          <div className="container">
            {/* Heading */}
            <div className="sec-title text-center py-3">
              <h2>{outpatientData.about_section.heading}</h2>
            </div>

            {/* About content */}
            <div className="row align-items-start">
              <div className="col-lg-12 col-12">
                <p>{outpatientData.about_section.content}</p>

                <p>
                  <a
                    href="https://care.edu.in/contact/enquires/"
                    className="badge bg-info p-2 me-2 d-inline-flex align-items-center text-decoration-none"
                    style={{ cursor: "pointer", fontSize: "12px" }}
                  >
                    <i className="fa fa-info-circle me-1"></i>
                    How to register
                  </a>
                  <small className="text-muted">
                    (Procedure for registration and OP card generation)
                  </small>
                </p>
              </div>
            </div>

            {/* Contact Blocks */}
            <div className="row">
              {outpatientData.contact_blocks.map((block, i) => (
                <div className="col-lg-6 col-md-6 col-12 mb-3 mb-md-0" key={i}>
                  <div className="info-box p-4 mb-4 rounded shadow-sm">
                    <h5 className="fw-bold mb-3 text-white">{block.title}</h5>
                    {block.content_list.map((item, idx) => (
                      <p
                        key={idx}
                        className="mb-2 text-white d-flex align-items-center"
                      >
                        <img
                          src="/assets/images/clock.webp"
                          alt="time"
                          style={{ width: "20px", marginRight: "8px" }}
                        />
                        {item}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Department + Carousel Accordion (SINGLE GROUP) */}
            <div className="accordion mt-3" id="otherdepAccordion">
              {/* Department Accordion Items */}
              {outpatientData.outpatient_categories.map((cat, idx) => (
                <div className="accordion-item" key={`dept-${idx}`}>
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button ${idx !== 0 ? "collapsed" : ""}`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#opcat-${idx}`}
                    >
                      {cat.category_title}
                    </button>
                  </h2>

                  <div
                    id={`opcat-${idx}`}
                    className={`accordion-collapse collapse ${idx === 0 ? "show" : ""}`}
                    data-bs-parent="#otherdepAccordion"
                  >
                    <div className="accordion-body">
                      <ul className="opcare-list">
                        {cat.departments.map((dep, dIdx) => (
                          <li key={dIdx}>
                            <i className="fa fa-check-circle-o me-2"></i>
                            <a href={dep.link_url}>{dep.title}</a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}

              {/* Carousel Accordion Items — NOW INSIDE SAME ACCORDION */}
              {outpatientData.carousel_sections.map((section, idx) => (
                <div className="accordion-item " key={`carousel-${idx}`}>
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#carouselOp-${idx}`}
                    >
                      {section.title}
                    </button>
                  </h2>

                  <div
                    id={`carouselOp-${idx}`}
                    className="accordion-collapse collapse"
                    data-bs-parent="#otherdepAccordion"
                  >
                    <div className="accordion-body">
                      {section.content?.includes("<") ? (
                        <div
                          dangerouslySetInnerHTML={{ __html: section.content }}
                        />
                      ) : (
                        <p>{section.content}</p>
                      )}

                      {section.images_data?.length === 1 ? (
                        <div className="text-center">
                          <img
                            src={`${process.env.REACT_APP_API_URL}/public${section.images_data[0].url}`}
                            className="img-fluid rounded"
                            alt={section.title}
                          />
                        </div>
                      ) : (
                        <Slider {...poonjeriSliderSettings}>
                          {section.images_data.map((img, i) => (
                            <div className="slide-item text-center" key={i}>
                              <img
                                src={`${process.env.REACT_APP_API_URL}/public${img.url}`}
                                className="img-fluid rounded"
                                alt={`${section.title} ${i + 1}`}
                              />
                            </div>
                          ))}
                        </Slider>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );

  const InPatientContent = () => (
    <div className="document-box">
      {inpatientData && (
        <div className="accordion" id="incareAccordion">
          {inpatientData.inpatient_sections.map((section, idx) => (
            <div className="accordion-item" key={idx}>
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${idx !== 0 ? "collapsed" : ""}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#incare-${idx}`}
                >
                  {section.section_title}
                </button>
              </h2>

              <div
                id={`incare-${idx}`}
                className={`accordion-collapse collapse ${idx === 0 ? "show" : ""}`}
                data-bs-parent="#incareAccordion"
              >
                <div className="accordion-body">
                  {/* Text Blocks */}
                  {section.text_blocks.map((block, bIdx) => {
                    if (block.block_type === "paragraph") {
                      return <p key={bIdx}>{block.text}</p>;
                    }

                    if (block.block_type === "list") {
                      return (
                        <ul className="opcare-list" key={bIdx}>
                          {block.list_items.map((item, i) => (
                            <li key={i}>
                              <i className="fa fa-check-circle-o me-2"></i>
                              {item}
                            </li>
                          ))}
                        </ul>
                      );
                    }

                    return null;
                  })}

                  {/* Carousel */}
                  {section.images_data?.length > 0 && (
                    <div className="carousel-incare">
                      <Slider
                        {...{
                          dots: false,
                          infinite: true,
                          speed: 600,
                          slidesToShow: Number(section.image_count) || 1,
                          slidesToScroll: 1,
                          responsive: [
                            { breakpoint: 992, settings: { slidesToShow: 2 } },
                            { breakpoint: 576, settings: { slidesToShow: 1 } },
                          ],
                        }}
                      >
                        {section.images_data.map((img, i) => (
                          <div className="slide-item text-center" key={i}>
                            <img
                              src={`${process.env.REACT_APP_API_URL}/public${img.url}`}
                              className="img-fluid rounded"
                              alt={section.section_title}
                            />
                          </div>
                        ))}
                      </Slider>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  const DepartmentsContent = () => (
    <div className="document-box">
      <div className="sec-title text-center py-3">
        <h2>Departments</h2>
      </div>

      <div className="row">
        {departmentsData
          .sort((a, b) => a.order - b.order)
          .map((category) => (
            <div className="col-md-6 col-12" key={category.id}>
              <div className="specialty-block">
                <h3 className="mb-3">{category.name}</h3>

                <div className="specialty-chips">
                  {category.departments
                    .sort((a, b) => a.order - b.order)
                    .map((dept) => (
                      <Link
                        key={dept.id}
                        to={`/department/${dept.slug}`}
                        rel="noopener noreferrer"
                        className="chip"
                      >
                        <i className="fa fa-stethoscope"></i>
                        {dept.name}
                      </Link>
                    ))}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );

  const DiagnosticContent = () => (
    <div className="document-box">
      <div className="sec-title text-center py-3">
        <h2>{diagnosticData?.page_content?.title}</h2>
      </div>
      {diagnosticData?.page_content?.sections?.[0]?.blocks?.map(
        (block, index) => {
          if (block.type === "paragraph") {
            return (
              <p key={index}>
                {block.text?.includes("Visit Website") ? (
                  <strong>
                    For more information, Visit Website:
                    <a
                      href="http://labtest.care.edu.in/"
                      target="_blank"
                      rel="noopener"
                    >
                      {" "}
                      Diagnostic Services
                    </a>
                  </strong>
                ) : (
                  block.text
                )}
              </p>
            );
          }

          if (block.type === "heading") {
            return (
              <h3 key={index} className="mb-4 mt-4">
                {block.text}
              </h3>
            );
          }

          if (block.type === "list") {
            return (
              <ul key={index} className="opcare-list">
                {block.items?.map((item, i) => (
                  <li key={i}>
                    <i className="fa fa-check-circle-o me-2"></i>
                    {item}
                  </li>
                ))}
              </ul>
            );
          }

          if (block.type === "images") {
            return (
              <div key={index} className="carousel-incare">
                <Slider {...poonjeriSliderSettings}>
                  {block.images?.map((img, i) => (
                    <div key={i} className="slide-item text-center">
                      <img
                        src={`${process.env.REACT_APP_API_URL}/public${img.url}`}
                        alt={`Diagnostic ${i + 1}`}
                        className="img-fluid"
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            );
          }

          return null;
        },
      )}

      <div
        className="p-3 rounded text-center"
        style={{
          background: "rgb(255, 229, 229)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <p className="fw-bold mb-2 text-danger">
          <i className="fa fa-tint me-2"></i>
          {diagnosticData?.page_content?.sections?.[1]?.blocks?.[0]?.text}
        </p>

        <p className="mb-0 text-dark">
          <i className="fa fa-phone me-2 text-danger"></i>
          <a
            href="http://labtest.care.edu.in/"
            target="_blank"
            rel="noopener"
            className="text-decoration-none text-dark"
          >
            For any queries, Please contact :
          </a>
          <a
            href="tel:04447428401"
            className="fw-semibold text-danger ms-1 text-decoration-none"
          >
            044 47428401
          </a>
        </p>
      </div>
    </div>
  );

  const CommunityEngagementContent = () => (
    <div className="document-box">
      <div className="sec-title text-center py-3">
        <h2>{communityData?.core_paragraphs?.[0]?.title}</h2>
      </div>
      {communityData?.core_paragraphs?.map((para, index) => (
        <p key={index} dangerouslySetInnerHTML={{ __html: para.content }} />
      ))}
      {communityData?.camps_data && (
        <>
          <h4 className="mt-4 mb-4">{communityData.camps_data.heading}</h4>

          <p>{communityData.camps_data.subcontent}</p>

          <ul className="opcare-list">
            <div className="carousel-incare">
              <Slider {...poonjeriSliderSettings}>
                {communityData.camps_data.camps_images.map((img, i) => (
                  <div className="slide-item text-center" key={i}>
                    <img
                      src={`${process.env.REACT_APP_API_URL}/public${img.url}`}
                      alt={`Camp ${i + 1}`}
                      className="img-fluid"
                    />
                  </div>
                ))}
              </Slider>
            </div>
            {communityData.camps_data.points.map((point, i) => (
              <li key={i}>
                <i className="fa fa-check-circle-o me-2"></i>
                {point}
              </li>
            ))}
          </ul>
        </>
      )}
      {communityData?.ngo_data && (
        <>
          <p>{communityData.ngo_data.heading}</p>

          <div className="carousel-community">
            <Slider {...communitySliderSettings}>
              {communityData.ngo_data.logos.map((logo, i) => (
                <div className="slide-item text-center" key={i}>
                  <img
                    src={`${process.env.REACT_APP_API_URL}/public${logo.url}`}
                    alt={`NGO ${i + 1}`}
                    className="img-fluid"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </>
      )}
    </div>
  );

  const TestimonialContent = () => {
    if (!testimonialData || !testimonialData.testimonials) return null;

    return (
      <div className="document-box">
        <div className="sec-title text-center py-3">
          <h2>{testimonialData.section_title || "Testimonials"}</h2>
        </div>

        <div className="accordion" id="testimonialAccordion">
          {testimonialData.testimonials.map((tab, tIdx) => (
            <div className="accordion-item" key={tIdx}>
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${tIdx !== 0 ? "collapsed" : ""}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#testi-collapse-${tIdx}`}
                >
                  {tab.title}
                </button>
              </h2>
              <div
                id={`testi-collapse-${tIdx}`}
                className={`accordion-collapse collapse ${tIdx === 0 ? "show" : ""}`}
                data-bs-parent="#testimonialAccordion"
              >
                <div className="accordion-body">
                  <div className="row">
                    {tab.items?.map((item, iIdx) => (
                      <div className="col-12 mb-4" key={iIdx}>
                        <div className="p-4 rounded shadow-sm bg-white border position-relative">
                          <i
                            className="fa fa-quote-left position-absolute text-light"
                            style={{
                              fontSize: "3rem",
                              top: "10px",
                              left: "10px",
                              opacity: "0.2",
                            }}
                          ></i>

                          <div className="position-relative">
                            <p
                              style={{
                                whiteSpace: "pre-line",
                                lineHeight: "1.6",
                              }}
                            >
                              {item.content}
                            </p>

                            <div className="d-flex justify-content-between align-items-end pt-3 border-top">
                              <div>
                                <h6 style={{ whiteSpace: "pre-line" }}>
                                  {item.author}
                                </h6>
                                <small className="text-muted">
                                  <i className="fa fa-calendar-o me-2"></i>
                                  {item.year}
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // CHRI Satellite Centres Content Component
  const SatelliteContent = () => {
    if (!satelliteData) return null;

    return (
      <div className="document-box">
        <div className="sec-title text-center py-3">
          <h2>{satelliteData.section_title}</h2>
        </div>

        {satelliteData.centres?.map((centre, idx) => (
          <div key={idx} className="mb-5">
            {/* 1. Centre Title (Top Description) */}
            <p
              className="mb-3 text-dark"
              style={{ whiteSpace: "pre-line", textAlign: "justify" }}
            >
              {centre.title}
            </p>

            {/* 2. Data Table */}
            {centre.table && (
              <div className="table-responsive mb-4">
                <table className="table table-bordered table-striped">
                  <thead className="bg-light">
                    <tr>
                      {centre.table.headers?.map((header, hIdx) => (
                        <th key={hIdx}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {centre.table.rows?.map((row, rIdx) => (
                      <tr key={rIdx}>
                        {row.map((cell, cIdx) => (
                          <td key={cIdx}>{cell}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* 3. Bottom Description */}
            {centre.description && (
              <p
                className="mt-3"
                style={{ whiteSpace: "pre-line", textAlign: "justify" }}
              >
                {centre.description}
              </p>
            )}

            {idx !== satelliteData.centres.length - 1 && (
              <hr className="my-5" />
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <DynamicBanner
        title={aboutData?.banner_data?.title || ""}
        bgImage={aboutData?.banner_data?.desktop_images || []}
        bgImageMobile={aboutData?.banner_data?.mobile_images || []}
      />

      <section
        style={{ textAlign: "justify" }}
        className="general-hospital-section"
      >
        <div className="container my-5">
          <div className="row">
            <div className="col-md-3 d-none d-md-block">
              <div className="sidebar">
                <nav
                  className="nav flex-column"
                  id="contentTabs"
                  role="tablist"
                >
                  <a
                    className="nav-link active"
                    data-bs-toggle="tab"
                    href="#about"
                  >
                    About
                  </a>
                  <a
                    className="nav-link"
                    data-bs-toggle="tab"
                    href="#satellite"
                  >
                    CHRI Satellite Centres
                  </a>
                  <a className="nav-link" data-bs-toggle="tab" href="#bio">
                    Bio-Medical Waste Details
                  </a>
                  <a className="nav-link" data-bs-toggle="tab" href="#patient">
                    Patient & Visitors Guide
                  </a>
                  <a className="nav-link" data-bs-toggle="tab" href="#opcare">
                    Outpatient Care
                  </a>
                  <a className="nav-link" data-bs-toggle="tab" href="#incare">
                    Inpatient Care
                  </a>
                  <a className="nav-link" data-bs-toggle="tab" href="#dep">
                    Departments
                  </a>
                  <a
                    className="nav-link"
                    data-bs-toggle="tab"
                    href="#diagservice"
                  >
                    Diagnostic Services
                  </a>
                  <a className="nav-link" data-bs-toggle="tab" href="#com">
                    Community Engagement
                  </a>
                  <a
                    className="nav-link"
                    data-bs-toggle="tab"
                    href="#testimonial"
                  >
                    Testimonials
                  </a>
                </nav>
              </div>
            </div>
            <div className="col-md-9 d-none d-md-block">
              <div className="tab-content hospital-content">
                <div className="tab-pane fade show active" id="about">
                  <AboutContent />
                </div>
                <div className="tab-pane fade" id="satellite">
                  <SatelliteContent />
                </div>
                <div className="tab-pane fade" id="bio">
                  <div className="document-box">
                    <div className="accordion" id="ihecAccordion">
                      {wasteData.map((item, index) => (
                        <div className="accordion-item" key={index}>
                          <h5 className="accordion-header">
                            <button
                              className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#wasteCollapse${index}`}
                            >
                              {item.title}
                            </button>
                          </h5>

                          <div
                            id={`wasteCollapse${index}`}
                            className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                            data-bs-parent="#ihecAccordion"
                          >
                            <div className="accordion-body">
                              <div className="text-center">
                                <div className="img-warpper-waste">
                                  <img
                                    src={`${process.env.REACT_APP_API_URL}/public${item.image_url}`}
                                    alt={`Bio Medical Waste ${item.title}`}
                                    className="img-fluid"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="patient">
                  <GuideContent prefix="desktop" />
                </div>

                <div className="tab-pane fade" id="opcare">
                  <OutPatientContent />
                </div>
                <div className="tab-pane fade" id="incare">
                  <InPatientContent />
                </div>
                <div className="tab-pane fade" id="dep">
                  <DepartmentsContent />
                </div>
                <div className="tab-pane fade" id="diagservice">
                  <DiagnosticContent />
                </div>
                <div className="tab-pane fade" id="com">
                  <CommunityEngagementContent />
                </div>
                <div className="tab-pane fade" id="testimonial">
                  <TestimonialContent />
                </div>
              </div>
            </div>
            <div className="col-12 d-md-none">
              <div className="accordion" id="mobileAccordiongeneral">
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#aboutMobile"
                    >
                      About
                    </button>
                  </h5>
                  <div
                    id="aboutMobile"
                    className="accordion-collapse collapse show"
                    data-bs-parent="#mobileAccordiongeneral"
                  >
                    <div className="accordion-body">
                      <AboutContent />
                    </div>
                  </div>
                </div>
                {/* Mobile Satellite Accordion */}
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#satelliteMobile"
                    >
                      CHRI Satellite Centres
                    </button>
                  </h5>
                  <div
                    id="satelliteMobile"
                    className="accordion-collapse collapse"
                    data-bs-parent="#mobileAccordiongeneral"
                  >
                    <div className="accordion-body">
                      <SatelliteContent />
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#bioMobile"
                    >
                      Bio-Medical Waste Details
                    </button>
                  </h5>
                  <div
                    id="bioMobile"
                    className="accordion-collapse collapse"
                    data-bs-parent="#mobileAccordiongeneral"
                  >
                    <div className="accordion-body">
                      <div className="accordion" id="ihecAccordionMobile">
                        {wasteData.map((item, index) => (
                          <div className="accordion-item" key={index}>
                            <h5 className="accordion-header">
                              <button
                                className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#wasteCollapseMobile${index}`}
                              >
                                {item.title}
                              </button>
                            </h5>

                            <div
                              id={`wasteCollapseMobile${index}`}
                              className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                              data-bs-parent="#ihecAccordionMobile"
                            >
                              <div className="accordion-body">
                                <div className="mb-2">
                                  <img
                                    src={`${process.env.REACT_APP_API_URL}/public${item.image_url}`}
                                    alt={`Bio Medical Waste ${item.title}`}
                                    className="img-fluid"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#PatientMobile"
                    >
                      Patient & Visitors Guide
                    </button>
                  </h5>
                  <div
                    id="PatientMobile"
                    className="accordion-collapse collapse"
                    data-bs-parent="#mobileAccordiongeneral"
                  >
                    <div className="accordion-body">
                      <GuideContent prefix="mobile" />
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#opcareMobile"
                    >
                      Outpatient Care
                    </button>
                  </h5>
                  <div
                    id="opcareMobile"
                    className="accordion-collapse collapse"
                    data-bs-parent="#mobileAccordiongeneral"
                  >
                    <div className="accordion-body">
                      <OutPatientContent />
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#incareMobile"
                    >
                      Inpatient Care
                    </button>
                  </h5>
                  <div
                    id="incareMobile"
                    className="accordion-collapse collapse"
                    data-bs-parent="#mobileAccordiongeneral"
                  >
                    <div className="accordion-body">
                      <InPatientContent />
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#depMobile"
                    >
                      Departments
                    </button>
                  </h5>
                  <div
                    id="depMobile"
                    className="accordion-collapse collapse"
                    data-bs-parent="#mobileAccordiongeneral"
                  >
                    <div className="accordion-body">
                      <DepartmentsContent />
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#diagserviceMobile"
                    >
                      Diagnostic Services
                    </button>
                  </h5>
                  <div
                    id="diagserviceMobile"
                    className="accordion-collapse collapse"
                    data-bs-parent="#mobileAccordiongeneral"
                  >
                    <div className="accordion-body">
                      <DiagnosticContent />
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#comMobile"
                    >
                      Community Engagement
                    </button>
                  </h5>
                  <div
                    id="comMobile"
                    className="accordion-collapse collapse"
                    data-bs-parent="#mobileAccordiongeneral"
                  >
                    <div className="accordion-body">
                      <CommunityEngagementContent />
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h5 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#testimonialMobile"
                    >
                      Testimonials
                    </button>
                  </h5>
                  <div
                    id="testimonialMobile"
                    className="accordion-collapse collapse"
                    data-bs-parent="#mobileAccordiongeneral"
                  >
                    <div className="accordion-body">
                      <TestimonialContent />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GeneralHospital;
